import { useEffect, useState } from 'react'

/**
 * Tracks the user's color scheme preference via `prefers-color-scheme`.
 * Used to apply Canvas v8's `c-foundations_darkmode` wrapper class, which
 * swaps design token values (background, text, etc.) between light and dark.
 */
export const usePrefersDarkMode = (): boolean => {
    const [isDark, setIsDark] = useState<boolean>(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return false
        return (
            window.matchMedia('(prefers-color-scheme: dark)')?.matches ?? false
        )
    })

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return
        const mql = window.matchMedia('(prefers-color-scheme: dark)')
        if (!mql) return
        const handler = (e: MediaQueryListEvent) => setIsDark(e.matches)
        mql.addEventListener('change', handler)
        return () => mql.removeEventListener('change', handler)
    }, [])

    return isDark
}
